import React from 'react';
import { Check, X } from 'lucide-react';
import { useT } from '../i18n';

export default function Comparison() {
  const { t } = useT();
  const cols = t('comparisonCols');
  return (
    <section className="py-20 lg:py-24 bg-gradient-to-b from-white to-orange-50/40" id="index-ai">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <p className="kx-eyebrow mb-4">
            {t('comparison.eyebrow')}
          </p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-neutral-900 tracking-[-0.015em]">
            {t('comparison.titleA')} <span className="text-[#F77F11]">{t('comparison.titleAccent')}</span>
          </h2>
          <p className="mt-4 text-neutral-600 text-[15px] leading-relaxed">{t('comparison.body')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {cols.map((col) => (
            <div
              key={col.title}
              className={`rounded-2xl border p-7 transition-all hover:-translate-y-0.5 ${
                col.highlighted
                  ? 'border-[#F77F11] bg-white shadow-[0_24px_60px_-30px_rgba(247,127,17,0.45)]'
                  : 'border-neutral-200 bg-white/70'
              }`}
            >
              <h3
                className={`text-lg font-semibold mb-5 tracking-[-0.01em] ${
                  col.highlighted ? 'text-[#F77F11]' : 'text-neutral-800'
                }`}
              >
                {col.title}
              </h3>
              <ul className="space-y-4">
                {col.points.map((p, i) => (
                  <li key={i} className="flex gap-3 text-[14px] text-neutral-600 leading-relaxed">
                    {col.highlighted ? (
                      <Check className="w-5 h-5 text-[#F77F11] shrink-0 mt-0.5" />
                    ) : (
                      <X className="w-5 h-5 text-neutral-400 shrink-0 mt-0.5" />
                    )}
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
